// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ae825931","498":"dd0a7907","703":"d652e1f4","787":"d7e5a0a6"}[chunkId] + ".chunk.js";
};